import {
  Box,
  Grid2,
  InputLabel,
  Snackbar,
  Tab,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import MUIButton from "../../reusable_components/components/MUIButton";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useGetCandidateDetailMutation } from "../../redux/candidateprofiles/candidateprofiles.api";
import theme from "../../theme/theme";
import DownloadIcon from "../../assets/Icons/DownloadIcon";
import { create } from "@mui/material/styles/createTransitions";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import dayjs from "dayjs";

const ViewCandidate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const formatDate = (date = new Date()) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const { Snackbar } = useContext(SnackbarContext);

  const [viewCandidate, { data: getCandidateDetail }] =
    useGetCandidateDetailMutation();

  const { firstName, lastName, profileId, profileAssignedJob, offer } =
    location.state || "";

  const handleNavigateBack = () => {
    // navigate("/candidateprofile");
    navigate(-1);
  };

  const handleClientEdit = () => {
    navigate(`/editcandidateprofile/${params?.id}`);
  };

  const handleDownloadProfile = () => {
    const profilePath = getCandidateDetail?.response?.cvPath;

    if (profilePath !== null) {
      const extension = profilePath
        .substring(profilePath?.lastIndexOf(".") + 1)
        .toLowerCase();
      const name = profilePath.substring(profilePath?.lastIndexOf("/") + 1);
      if (extension === "docx" || extension === "doc") {
        const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${profilePath}`;
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (extension === "pdf") {
        const url = `${window.REACT_APP_FILEDOWNLOAD_URL}${profilePath}`;
        window.open(url, "_blank");
      } else {
        Snackbar("Unable to download Profile", "error");
      }
    }
  };

  useEffect(() => {
    if (params?.id) {
      const payload = {
        profileId: +params?.id,
      };
      viewCandidate(payload);
    }
  }, [params?.id, viewCandidate]);

  return (
    <Box className="container">
      <Grid2
        Item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#6941C6",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
          marginBottom: "20px",
        }}
        onClick={handleNavigateBack}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Back</Typography>
      </Grid2>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <Box>
          <Typography className="title" sx={{}} noWrap>
            {getCandidateDetail?.response?.firstName}{" "}
            <span>
              {getCandidateDetail?.response?.lastName}
              {profileAssignedJob === "No" && (
                <span
                  style={{
                    backgroundColor: "#53389E",
                    color: "white",
                    fontSize: "10px",
                    fontWeight: 600,
                    padding: "1px 6px",
                    borderRadius: "16px",
                    position: "relative",
                    bottom: "10px",
                    left: "0px",
                    fontSize: "10px",
                    width: "auto",
                    borderColor: "black",
                  }}
                >
                  <span
                    style={{
                      height: "6px",
                      width: "6px",
                      backgroundColor: "white", // or any color you prefer
                      borderRadius: "50%",
                      display: "inline-block",
                      marginRight: "5px",
                    }}
                  ></span>
                  New
                </span>
              )}
            </span>
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            flexWrap: "wrap",
            alignItems: "flex-end",
          }}
        >
          {/* <MUICancelButton title='Share' startIcon={<ShareOutlinedIcon sx={{ fontSize: '15px !important' }} />} /> */}
          <Tooltip
            placement="top"
            title={
              getCandidateDetail?.response?.cvPath === null
                ? "No profile uploaded for this candidate."
                : ""
            }
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#0A0D12",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                },
              },
            }}
          >
            <div>
              <MUIButton
                title={"Download Profile"}
                disabled={getCandidateDetail?.response?.cvPath === null}
                onClick={handleDownloadProfile}
                startIcon={
                  <DownloadIcon
                    stroke={
                      getCandidateDetail?.response?.cvPath === null
                        ? "white"
                        : "white"
                    }
                  />
                }
                sx={{
                  color:
                    getCandidateDetail?.response?.cvPath === null
                      ? "white"
                      : "white",
                  border: "1px solid #D6BBFB",
                  width: "200px",
                }}
              />
            </div>
          </Tooltip>
          {offer !== true && (
            <MUIButton
              title="Edit"
              className="edit-button"
              onClick={handleClientEdit}
            />
          )}
        </Box>
      </Box>

      <TabContext>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            aria-label="Overview and Candidates tabs"
            textColor="primary"
            indicatorColor="secondary"
          >
            <Tab
              label="Overview"
              className="tabs"
              sx={{
                textTransform: "none",
                color: "#7F56D9",
                borderBottom: 2,
                borderColor: "divider #7F56D9",
                fontWeight: "bold",
                transition: "all 0.3s ease",
              }}
            />
          </TabList>
        </Box>

        {/* tab */}
        <TabPanel sx={{ display: "flex", padding: 0.5 }}>
          {/* mainbox */}
          <Box
            sx={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              width: "100%",
              "@media (max-width: 900px)": {
                flexDirection: "column",
              },
            }}
          >
            <Box
              sx={{
                width: "100%",
                "@media(max-width:900px)": {
                  width: "100%",
                },
              }}
            >
              <Typography sx={{ fontWeight: "bold" }}>
                Basic Information
              </Typography>

              <Grid2
                rowGap={2}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "10px",
                }}
              >
                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862", fontSize: "14px" }}>
                      Candidate Name
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.firstName}{" "}
                      {getCandidateDetail?.response?.lastName}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Alternate Number
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.alternateMobile || "-"}
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Contact Number
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.mobile || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Alternate Email
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.alternateEmail || "-"}
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>Email</InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.email || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>Location</InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.address || "-"}
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Sourced By
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.submittedBy || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Total Experience
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.totalExperience || "-"}
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Created Date
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {formatDate(getCandidateDetail?.response?.createdDate) ||
                        "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>Remarks</InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.remarks || "-"}
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>Position</InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.referralPosition || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Candidate Status
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.candidateStatus === "UEM"
                        ? "Unemployed"
                        : getCandidateDetail?.response?.candidateStatus ===
                          "ELC"
                          ? "Employed Looking for Change"
                          : getCandidateDetail?.response?.candidateStatus ===
                            "EOB"
                            ? "Employed On Bench"
                            : getCandidateDetail?.response?.candidateStatus ===
                              "ENO"
                              ? "Employed Not Open "
                              : getCandidateDetail?.response?.candidateStatus === "ENA" ? "Employee Not Available" : getCandidateDetail?.response?.candidateStatus === "EAV" ? "Employee Available" : " " || "-"}
                    </Typography>
                  </Box>
                </Grid2>
                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Current Organization
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.currentOrganization || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Technologies
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.technologies
                        ?.filter((tech) => tech.hasSelected)
                        ?.map((tech) => tech.keywordName)
                        ?.join(", ") || "-"}
                    </Typography>
                  </Box>
                </Grid2>
                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Relevent Experience(Years)
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.releventExperience || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      {getCandidateDetail?.response?.noticePeriodInMonths === null
                        ? "Last Working Date"
                        : "Notice Period (Days)"}
                    </InputLabel>

                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.noticePeriodInMonths === null
                        ? dayjs(getCandidateDetail?.response?.lastWorkingDate).format('DD-MM-YYYY') || "-"
                        : getCandidateDetail?.response?.noticePeriodInMonths || "-"}
                    </Typography>
                  </Box>
                </Grid2>
                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      CCTC(In Lakhs)
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.candidateCctc || "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "40%", marginLeft: "10px" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      ECTC(In Lakhs){" "}
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.candidateEctc || "-"}{" "}
                    </Typography>
                  </Box>
                </Grid2>
                <Grid2
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ width: "50%" }}>
                    <InputLabel sx={{ color: "#535862" }}>
                      Candidate Type
                    </InputLabel>
                    <Typography sx={{ color: "#414651", fontSize: "14px" }}>
                      {getCandidateDetail?.response?.candidateType === "P" ? "Permanent" : getCandidateDetail?.response?.candidateType === "C" ? "Contract" : "-"}
                    </Typography>
                  </Box>
                </Grid2>
              </Grid2>
            </Box>
          </Box>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default ViewCandidate;
